import { render, staticRenderFns } from "./actionplan.vue?vue&type=template&id=5c88d5ca&scoped=true&"
import script from "./actionplan.vue?vue&type=script&lang=js&"
export * from "./actionplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c88d5ca",
  null
  
)

export default component.exports